import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the API
 */
export class CustomDataHandlerService extends BaseService {
	
	constructor() {	
		super();
	}

	async getCustomDataHandlers(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/custom-data-handlers' + params);		
		return data;		
	}
	
	async getCustomDataHandler(customHandlerId) {
		var data = await this.makeGETRequest('/api/resource/custom-data-handlers/' + customHandlerId);		
		return data;		
	}
	
	async getTransforms() {
		var data = await this.makeGETRequest('/api/resource/custom-data-handlers/transforms');		
		return data;		
	}	
	
	async getMetaModel(dataType) {
		var data = await this.makeGETRequest('/api/resource/custom-data-handlers/meta-models/' + dataType);		
		return data;		
	}	
	
	async saveCustomHandler(handler, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/custom-data-handlers/' + handler.customHandlerId, handler);
		} else {
			saved = await this.makePOSTRequest('/api/resource/custom-data-handlers', handler);
		}
		return saved;		
	}	
	
	async activate(customHandlerId) {	
		var result = await this.makePUTRequest('/api/resource/custom-data-handlers/' + customHandlerId + '/activate');
		return result;
	}	

	async inactivate(customHandlerId) {	
		var result = await this.makePUTRequest('/api/resource/custom-data-handlers/' + customHandlerId + '/inactivate');
		return result;
	}	
	
	
}

